module.exports = __webpack_public_path__ + "static/media/harshmohan_kulkarni.ee556ea0.jpeg";